/**
 * @constant {string} - `value6` column in the `config` table when
 * the `type` column has a value of `overtime_setting_day2`. In this constant,
 * `value6` = `daystartend`.
 */
export const DAY_START_END_SETTING = 'daystartend';

/**
 * @constant {string} - `value6` column in the `config` table when
 * the `type` column has a value of `overtime_setting_day2`. In this constant,
 * `value6` = `midnight`.
 */
export const MIDNIGHT_SETTING = 'midnight';
